export const ROUTES = {
  accessorial: (id: string = ':id') => `${ROUTES.accessorials()}/${id}` as const,
  accessorials: () => `${ROUTES.root()}/accessorials` as const,
  index: () => `${ROUTES.pricing()}` as const,
  pricing: () => `${ROUTES.root()}/pricing` as const,
  root: () => '/pricing' as const,
  tariff: (tariffKey: string = ':tariffKey') => `${ROUTES.tariffs()}/${tariffKey}` as const,
  tariffs: () => `${ROUTES.root()}/tariffs` as const,
};
